module.exports = __webpack_public_path__ + "img/favicon.6202db4.png";